/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateStatus } from './FormulaEvaluateStatus';
import {
    FormulaEvaluateStatusFromJSON,
    FormulaEvaluateStatusFromJSONTyped,
    FormulaEvaluateStatusToJSON,
    FormulaEvaluateStatusToJSONTyped,
} from './FormulaEvaluateStatus';

/**
 * 
 * @export
 * @interface FormulaEvaluateMessage
 */
export interface FormulaEvaluateMessage {
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    status: FormulaEvaluateStatus;
}



/**
 * Check if a given object implements the FormulaEvaluateMessage interface.
 */
export function instanceOfFormulaEvaluateMessage(value: object): value is FormulaEvaluateMessage {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function FormulaEvaluateMessageFromJSON(json: any): FormulaEvaluateMessage {
    return FormulaEvaluateMessageFromJSONTyped(json, false);
}

export function FormulaEvaluateMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': FormulaEvaluateStatusFromJSON(json['status']),
    };
}

export function FormulaEvaluateMessageToJSON(json: any): FormulaEvaluateMessage {
    return FormulaEvaluateMessageToJSONTyped(json, false);
}

export function FormulaEvaluateMessageToJSONTyped(value?: FormulaEvaluateMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'status': FormulaEvaluateStatusToJSON(value['status']),
    };
}

